import { cgi as Cgi } from '@tencent/midas-cgi'
import MobileSubscribe from '@tencent/midas-cgi/cgis/mobile_subscribe'
import WechatQuery from '@tencent/midas-cgi/cgis/wechat_query'

const defaultConfig = {
  hideLoading: true
}

class Api {
  cgiObj: Cgi = {}

  cgiNames = {}

  init(options: Object) {
    if (JSON.stringify(this.cgiObj) === '{}') {
      this.cgiObj = new Cgi(options)

      this.cgiNames = {
        subscribe: new MobileSubscribe(defaultConfig),
        wechatQuery: new WechatQuery(defaultConfig)
      }
    }
  }

  async request(name: string, params: Object) {
    return this.cgiObj.request(this.cgiNames[name], params)
  }
}

export default new Api()
